import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { HandleError, HttpErrorHandler } from 'src/app/http-error-handler.service';
import { environment } from 'src/environments/environment';
import { ApiService, FAZILService } from '.';

@Injectable()
export class DatesService {


    private handleError: HandleError;

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    
    constructor(
        private apiService: ApiService,
        private httpClient: HttpClient,
        private httpErrorHandler: HttpErrorHandler,
        private sanitizer: DomSanitizer,
        private messageService: MessageService,
        private fazilService: FAZILService,
    ) {
        this.handleError = httpErrorHandler.createHandleError('DatesService');
    }

    /**
    *Generación de fechas
    */
    getDateNow() {
        return new Date();
    }
    
    /**Retorna el valor válido de una fecha.*/
    getDate(date: any) {
        return new Date(date);
    }

    /**Retorna una fecha específica en una cadena con locale actual.*/
    getDateToString(date: any) {
        if (this.isPresentObject(date)) {
            return moment(date.toString()).format("YYYY/MM/DD");
        }
        return null;
    }

    /**Retorna una fecha específica en una cadena con locale actual al cual se suma un total de dias.*/
    getDateAddDays(date: any, dias: any) {
        date = new Date(date);
        date.setDate(date.getDate() + dias);
        return date.toLocaleDateString()
    }

    /**Retorna una fecha específica con la hora completa.*/
    getDateWithTime(valueDate: Date) {
        let month = valueDate.getMonth();
        let year = valueDate.getFullYear();
        let day = valueDate.getDate();
        let date = new Date();
        date.setMonth(month);
        date.setFullYear(year);
        date.setDate(day);
        return date;
    }

    getDateMin(timeType: string) {
        let today = new Date();
        let month = today.getMonth();
        let year = today.getFullYear();
        let minDate = new Date();

        if (timeType == 'month') {
            let prevMonth = (month === 0) ? 11 : month - 1;
            let prevYear = (prevMonth === 11) ? year - 1 : year;
            minDate.setMonth(prevMonth);
            minDate.setFullYear(prevYear);
        }
        return minDate;
    }

    getDateMaxByPlan(initDate: Date, timeType: string) {
        let today = new Date(initDate)
        let month = today.getMonth();
        let year = today.getFullYear();
        let nextMonth: any;
        let nextYear: any;
        let date = new Date(today);
        switch (timeType) {
            case this.appConfig.properties.tiposPeriodos.mensual:
                nextMonth = (month === 11) ? 0 : month + 1;
                nextYear = (nextMonth === 0) ? year + 1 : year;
                date.setMonth(nextMonth);
                date.setFullYear(nextYear);
                break
            case this.appConfig.properties.tiposPeriodos.trimestral:
                nextMonth = (month === 9) ? 0 : (month === 10) ? 1 : (month === 11) ? 2 : month + 3;
                nextYear = (month === 9 || month === 10 || month === 11) ? year + 1 : year;
                date.setMonth(nextMonth);
                date.setFullYear(nextYear);
                break
            case this.appConfig.properties.tiposPeriodos.semestral:
                nextMonth = (month === 6) ? 0 : (month === 7) ? 1 : (month === 8) ? 2 : (month === 9) ? 3
                    : (month === 10) ? 4 : (month === 11) ? 5 : month + 6;
                nextYear = (month === 6 || month === 7 || month === 8 || month === 9 || month === 10 || month === 11) ? year + 1 : year;
                date.setMonth(nextMonth);
                date.setFullYear(nextYear);
                break
            case this.appConfig.properties.tiposPeriodos.anual:
                nextMonth = month;
                nextYear = year + 1;
                date.setMonth(nextMonth);
                date.setFullYear(nextYear);
                break
            case this.appConfig.properties.tiposPeriodos.bianual:
                nextMonth = month;
                nextYear = year + 2;
                date.setMonth(nextMonth);
                date.setFullYear(nextYear);
                break
            default:
                break
        }
        return date;
    }

    /**
    *Conversión de fechas
    */
    getDifferenceInDays(date1, date2) {
        const diffInMs = Math.abs(date2 - date1);
        return diffInMs / (1000 * 60 * 60 * 24);
    }
    
    isPresentObject(entity: any) {
        if (entity == undefined || !entity || entity == null) {
            return false;
        } else {
            return true;
        }
    }
    
}